// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class Position implements flatbuffers.IUnpackableObject<PositionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Position {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPosition(bb:flatbuffers.ByteBuffer, obj?:Position):Position {
  return (obj || new Position()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPosition(bb:flatbuffers.ByteBuffer, obj?:Position):Position {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Position()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

x():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

y():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

static startPosition(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addX(builder:flatbuffers.Builder, x:number) {
  builder.addFieldInt32(0, x, 0);
}

static addY(builder:flatbuffers.Builder, y:number) {
  builder.addFieldInt32(1, y, 0);
}

static endPosition(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPosition(builder:flatbuffers.Builder, x:number, y:number):flatbuffers.Offset {
  Position.startPosition(builder);
  Position.addX(builder, x);
  Position.addY(builder, y);
  return Position.endPosition(builder);
}

unpack(): PositionT {
  return new PositionT(
    this.x(),
    this.y()
  );
}


unpackTo(_o: PositionT): void {
  _o.x = this.x();
  _o.y = this.y();
}
}

export class PositionT implements flatbuffers.IGeneratedObject {
constructor(
  public x: number = 0,
  public y: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return Position.createPosition(builder,
    this.x,
    this.y
  );
}
}
